import { Box, Button, Chip, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, FormControl, InputLabel, MenuItem, Select, TextField, Typography } from "@mui/material"
import React, { useEffect } from "react"
import Stack from '@mui/material/Stack';
import LinearProgress from '@mui/material/LinearProgress';
import FormGroup from '@mui/material/FormGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import Switch from '@mui/material/Switch';

export default function ComputerListAutoLicFormDialog(props) {
  const [userLevel, setUserLevel] = React.useState(props.auto_license.level)
  const [customConfig, setCustomConfig] = React.useState(props.auto_license.config)
  const [chk_kill_checked, set_chk_kill_checked] = React.useState(props.auto_license._val == 128)
  const [chk_auto_gen_checked, set_chk_auto_gen_checked] = React.useState(props.auto_license._val == 1)
  const [chk_auto_gen_en, set_chk_auto_gen_en] = React.useState(props.auto_license._val != 128)
  const [programSelector, setProgramSelector] = React.useState(props.sw_name)   
  useEffect(() => {
    // Se esiste una programList, cerco l'entry corrispondente al programSelector
    // e imposto customConfig al valore `custom_config` se presente.
    if (props && Array.isArray(props.programList)) {
      const found = props.programList.find(p => p.selector === programSelector)
      if (found && found.custom_config !== undefined) {
        setCustomConfig(found.custom_config)
        return
      }
    }
    // se non trovo nulla, non modifico customConfig (comportamento precedente)
  }, [programSelector, props.programList])  
  const handle_chk_kill_change = (e) => {
    set_chk_kill_checked(e.target.checked)
    if (e.target.checked) set_chk_auto_gen_checked(false)
    set_chk_auto_gen_en(!e.target.checked)      
  }
  const handle_chk_auto_gen_change = (e) => { set_chk_auto_gen_checked(e.target.checked) }
  const handleClose = () => { props.onClickClose() }
  const handleSubmit = () => {
    if (!window.confirm("Are you sure?")) return 
    var customConfig_value = customConfig
    if (!view_en.custom_config) {
       // se il custom config non e' visibile all'utente -> provo a leggere il valore da props.programList
      if (props && Array.isArray(props.programList)) {
        const found = props.programList.find(p => p.selector === programSelector)
        if (found && found.custom_config !== undefined) {
          customConfig_value = found.custom_config
        }
      }
      // altrimenti lascio il valore attuale (comportamento precedente)      
    }
    props.onClickSubmit({
      userLevel: userLevel,
      customConfig: customConfig_value,
      kill: chk_kill_checked,
      autoGen: chk_auto_gen_checked,
    })
  }
  const handleUserLevelChange = (e) => { setUserLevel(e.target.value) }
  const handleCustomConfigChange = (e) => { setCustomConfig(e.target.value) }    
  const program_text = () => {
    if (props.sw_name == '') { return ( <em>unknown</em> ) }
    return <>{props.sw_name} {props.sw_ver}</>
  }   

  // **********************************************************
  // **********************************************************
  // **********************************************************

  var view_en = {
    custom_config: (props.is_admin || props.custom_config_en),
    user_level_standard: false,
    user_level_advanced: false,
    user_level_power: false,
    cancel_button: true,
    build_button: true,
    show_spin: false,
  }  
  
  if (props.is_admin) {
    view_en.user_level_standard = true
    view_en.user_level_advanced = true
    view_en.user_level_power = true
    view_en.build_button = true
  } else {
    // qui dipende dal valore di "reseller_programs"
    // props.reseller_programs: "plus_max_landi, STANDARD\r\nomegas_landi"
    var rows = props.reseller_programs.split("\n")
    var max_level = "STANDARD"
    rows = rows.map(row => {
      if (row.includes(props.sw_name)) {
        // solo in questo caso abilito il pulsante
        view_en.build_button = true
        // vedo se devo attivare un livello piu' alto
        var parts = row.split(",")
        if (parts && parts.length > 1) {
          max_level = parts[1].trim().toUpperCase()
        }
      }
    })
    switch (max_level) {
      default:
        // testo non valido
        view_en.user_level_standard = false
        view_en.user_level_advanced = false
        view_en.user_level_power = false
        // disabilito anche il pulsante
        view_en.build_button = false
        break;
      case "BASIC":
        view_en.user_level_standard = false
        view_en.user_level_advanced = false
        view_en.user_level_power = false
        break;
      case "STANDARD": 
        view_en.user_level_standard = true
        view_en.user_level_advanced = false
        view_en.user_level_power = false
        break;
      case "ADVANCED": 
        view_en.user_level_standard = true
        view_en.user_level_advanced = true
        view_en.user_level_power = false
        break;
      case "POWER": 
        view_en.user_level_standard = true
        view_en.user_level_advanced = true
        view_en.user_level_power = true
        break;  
    }
  }

  if (props.spin) {
    view_en.cancel_button = false
    view_en.build_button = false
    view_en.show_spin = true
  }

  var box_desc = "This software is ready for auto license"
  var box_color = "text.secondary"
  if (props.auto_license.ready == 2) {
    box_desc = "This software has not yet downloaded the updated license"
    box_color = "warning.main"
  }
    
  // **********************************************************
  // **********************************************************
  // **********************************************************

  return (    
    <div>      
      <Dialog open={props.open}>
        <DialogTitle>AUTO LICENSE</DialogTitle>
        <DialogContent>
          <DialogContentText>
            <Box sx={{ fontWeight: 'bold', fontFamily: 'Monospace', fontSize: 12, p: 0, m: 0, color: 'info.main' }}>
              User code: {props.user_code}
            </Box>
            <Box sx={{ fontWeight: 'bold', fontFamily: 'Monospace', fontSize: 12, p: 0, m: 0, color: 'info.main' }}>
              Program: {program_text()}
            </Box>
            <Box sx={{ mt: 3, color: box_color }}>
              {box_desc}                
            </Box>
          </DialogContentText>
          
          <br />

          <Stack spacing={3}>
              
            <FormControl variant="standard" >
              <InputLabel id="demo-simple-select-standard-label">USER LEVEL</InputLabel>
              <Select
                id="user_level"
                value={userLevel}
                onChange={handleUserLevelChange}
                label="USER LEVEL"
                disabled={view_en.show_spin} >
                <MenuItem value="BASIC">BASIC</MenuItem>
                {view_en.user_level_standard && (<MenuItem value="STANDARD">STANDARD</MenuItem>)}
                {view_en.user_level_advanced && (<MenuItem value="ADVANCED">ADVANCED</MenuItem>)}
                {view_en.user_level_power && (<MenuItem value="POWER">POWER</MenuItem>)}
              </Select>
            </FormControl>
            
            {view_en.custom_config && (
              <TextField
                value={customConfig}
                margin="dense"
                id="custom_config"
                label="CUSTOM CONFIG"
                onChange={handleCustomConfigChange}
                type="text"
                fullWidth
                variant="standard"
                disabled={view_en.show_spin} /> )}

            <FormGroup>
              <FormControlLabel 
                control={<Switch 
                  checked={chk_kill_checked}
                  onChange={handle_chk_kill_change} />}
                  label="Force license delete" />
              <FormControlLabel 
                disabled={!chk_auto_gen_en}
                control={<Switch 
                  checked={chk_auto_gen_checked}
                  onChange={handle_chk_auto_gen_change}
                  inputProps={{ 'aria-label': 'controlled' }} />}
                label="Auto-generate a new license every 30 days" />
            </FormGroup>

          </Stack>
        </DialogContent>
        <DialogActions>
          <Button disabled={!view_en.cancel_button} onClick={handleClose}>Cancel</Button>
          <Button disabled={!view_en.build_button} onClick={handleSubmit}>Update</Button>
        </DialogActions>
        {view_en.show_spin && <LinearProgress />}
      </Dialog>
    </div>
  );
}
